<script></script>

<h1 class="body-header">
  <span class="section-arrow">&gt; </span>
</h1>
<p class="body-text">
  K-Fold Cross-Validation can be an excellent tool to help improve estimates of
  test error rates compared to a simple validation set. It is widely used and an
  important technique to have in your machine learning toolkit.
  <br /><br />
  Thanks for reading! We hope that the article is insightful no matter where you
  are along your machine learning journey, and that you came away with a better understanding
  of K-Fold Cross-Validation in the context of machine learning.
  <br /><br />
  To learn more about machine learning, check out our
  <a class="on-end" href="https://aws.amazon.com/machine-learning/mlu/"
    >self-paced courses</a
  >, our
  <a
    class="on-end"
    href="https://www.youtube.com/channel/UC12LqyqTQYbXatYS9AA7Nuw"
    >YouTube videos</a
  >, and the
  <a class="on-end" href="https://d2l.ai/">Dive into Deep Learning</a>
  textbook. If you have any comments or ideas related to
  <a class="on-end" href="https://mlu-explain.github.io/"
    >MLU-Explain articles</a
  >, feel free to reach out
  <a class="on-end" href="https://twitter.com/jdwlbr">directly</a>. The code for
  this article is available
  <a class="on-end" href="https://github.com/aws-samples/aws-mlu-explain"
    >here</a
  >.
  <br /><br />
  A special thanks goes out to Brent Werness and
  <a href="https://twitter.com/lusantala">Lucía Santamaría</a> for helping review
  the content of this article.
</p>

<style>
</style>
